import type { ReactNode } from 'react';
import React from 'react';
import { classnames } from 'Utils/classnames/classnames.utils';
import type { IconName } from 'Components/frameworks/icon/Icon';
import { Icon } from 'Components/frameworks/icon/Icon';
import { themes } from './Title.themes';
export type TitleProps = {
  children: ReactNode;
  className?: string;
  dataTestId?: string;
  hasEllipsis?: boolean;
  hLevel?: number;
  iconColor?: Colors;
  iconName?: IconName;
  iconSize?: string;
  id?: string;
  theme?: keyof typeof themes;
};
export const Title = ({
  children,
  className,
  dataTestId,
  hasEllipsis,
  hLevel = 2,
  iconColor = 'inherit',
  iconName,
  iconSize,
  id,
  theme = 'title-brand-n1',
  ...rest
}: TitleProps) => {
  if (!children) {
    return null;
  }

  const { thIcon, thTitle } = themes[theme];
  const TagName = `h${hLevel}`;
  return (
    <TagName
      {...rest}
      className={classnames(thTitle, 'text-black', className)}
      data-testid={dataTestId}
      id={id}
    >
      <Icon
        className={classnames(thIcon, 'shrink-0', `text-${iconColor}`)}
        name={iconName}
        width={iconSize || '1em'}
      />
      {hasEllipsis ? <span className="w-full truncate">{children}</span> : children}
    </TagName>
  );
};
